import React, { useRef, useState, useEffect } from "react";
import { Link, Navigate, useNavigate,useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
 import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";
 
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Select from 'react-select';
import CreateSlug from "../components/extra/CreateSlug";


const Home = () => {

    
  const {
        
    isLayoutLoading,
    layout,AllHomeProducts,isProducts,IsBlogLoading,AllBlogs,AllCategoriess,LocationHeaders
  } = useBlogContext();
const [loading, setloading] = useState(true);

const [Data, setData] = useState([]);
const { slug  = 'delhi'} = useParams();


const getData = async () => {
  if(slug){
    const modifiedSlug = slug.replace(/-/g, ' '); // This will remove all hyphens

    setloading(true);
    try {
      const { data } = await axiosInstance.get(`/get-catgeory-product?location=${modifiedSlug}`);
      setData(data.categoriesWithProducts || []);
      // Delay the execution of buildScript by 1 secon
      console.log('datadata',data);
    
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  }
  
};

  useEffect(() => {
    const location = localStorage.getItem('location');
    if( location !== "[object Object]" && location){
      const stateSlug = CreateSlug(location);

      navigate(`/${stateSlug}`)
    }
 
  }, []);


useEffect(() => {
getData();
window.scrollTo(0, 0);
}, [slug]);

  
const swiperRef = useRef();

const swiperRefLocal = useRef();

const handleMouseEnter = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.stop();
};

const handleMouseLeave = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.start();
};
 
 
      const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }  
 
   setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
   };

 const AllCategoriesOptions = AllCategoriess.map(category => ({
    value: category.slug,
    label: category.title
  }));

  //   const filteredLocations = LocationHeaders.filter((location) =>
  //   location.toLowerCase().includes(searchQuery.toLowerCase())
  // );


   const AllLocationsOptions = LocationHeaders.map(item => ({
    value: item,
    label: item
  }));

  const navigate = useNavigate();

  const SearchChange = (e) => {

   if(formData.locationId && formData.categoryId){
     const loc =  CreateSlug(formData.locationId)
     navigate(`/${loc}/${formData.categoryId}`);
   }else{
    console.log('formData.locationId',formData,formData.locationId,formData.categoryId)
    toast.error('Please choose catgeory and location')
   }

  }
  return (
    <>
      <Header />
 
 <section
  className="one-hero-header position-relative d-none"
  style={{
    backgroundImage:
      `url("${layout.slider_img}")`,
    backgroundColor: "#00000047 !important",
    backgroundBlendMode: "multiply"
  }}
>
  <div className="banner-search py-5">
    <div className="container py-4">
      <div className="row flex-lg-row-reverse align-items-center pb-5 justify-content-center">
        <div className="col-lg-9 col-12">
          <div className="text-center text-white">
            <nav
              aria-label="breadcrumb"
              className="small d-flex justify-content-center"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#" className="text-decoration-none text-white">
                    Home
                  </a>
                </li>
                
              </ol>
            </nav>
            {/* <div className="display-4 fw-bold mb-3">
              Get Services <br />
              Whenever You Need Them.
            </div>
            <p className="lead fw-normal text-white-50 mb-5">
              Find Local Service Professionals Near You!
            </p> */}
         
            <div className="mt-4 mb-5 pb-5 d-none">
              <span className="small py-1 text-decoration-none fw-bold text-white me-2">
                Popular
              </span>
              <a
                href="services-list.html"
                className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
              >
                {" "}
                Cleaning{" "}
              </a>
              <a
                href="services-list.html"
                className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
              >
                {" "}
                Washroom{" "}
              </a>
              <a
                href="services-list.html"
                className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
              >
                {" "}
                Home Cleaning{" "}
              </a>
              <a
                href="services-list.html"
                className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
              >
                {" "}
                Painting{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
 <div className="w-100 home-slider h-auto  ">
 <img src={layout.slider_img} className="w-100 home-slider bg-white" /> 
 </div>

 <section className="bg-white d-none">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="bg-white border rounded-4 p-2 all-services position-relative"  onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} style={{zIndex:2}} >
        <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              300: {
                slidesPerView: 2,
              },
              640: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 5,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
             modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

                  {isLayoutLoading
                   ? Array.from({ length: 4 }).map((_, index) => (
                        <SwiperSlide
                         className="skeleton mb-2 shadow" 
                         style={{
                            height: "60px", 
                           transform:'scale(0.95)'
                         }}
                       ></SwiperSlide>
                    ))
                   : layout.trending_product_banner && (
                     <>
                       {layout.trending_product_banner.map((image, index) => (
  <SwiperSlide className=" rounded box">
              <Link  to={image.imageUrlInput} className="link-dark">
                <div className="text-center p-2">
                  <img
                   src={image.imageInput}
       alt={image.imageTITInput} 
                 
                    className="img-fluid"
                  />
                  <p className="small pt-2 m-0">{image.imageTITInput}</p>
                </div>
              </Link>
            </SwiperSlide>
                 ))}
                     </>
                   )}
 
           
         </Swiper>
        </div>
      </div>
    </div>
  </div>
</section>


<section className="bg-white py-5">
  <div className="container py-4">
    <div className="row mb-5">
      <div className="col-12">
        <div className="text-center">
          <h2 className="fw-bold">Best Offers</h2>
          <p className="text-muted m-0">
            Hygienic &amp; single-use products &amp; Low-contact services
          </p>
        </div>
      </div>
    </div>
    <div className="w-100" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} >
         
 <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]} className="pb-4" > 

    
    {layout.latest_product_banner && layout.latest_product_banner.length !== 0 &&
  layout.latest_product_banner.map((product, index) => (
      <SwiperSlide  >
         <Link to={`${product?.imageUrlInput?.replace('{{id}}', slug )}`} className="link-dark">
          <div className="zoom-img">
            <img
             src={product.imageInput} 
              alt=""
              className="img-fluid rounded-4  object-fit-cover" style={{aspectRatio:'1/1'}}
            />
          </div>
          <div className="text-center pt-3">
            <p className="fw-semibold mb-0">{product.imageTITInput}</p>
            <p className="text-muted small m-0">{product.imageParaInput}</p>
          </div>
        </Link>
      </SwiperSlide>
      ))
}
      </Swiper>

          </div>

  </div>
</section>



 {/* Book Now */}
  <section className="bg-white">
    <div className="container">
      <div className="row">
        <div className="col-12"  onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} >
          <Swiper   slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]} className="salon-spa-service  pb-4">
           {isLayoutLoading
                   ? Array.from({ length: 4 }).map((_, index) => (
                        <SwiperSlide
                         className="skeleton mb-2 shadow" 
                         style={{
                            height: "60px", 
                           transform:'scale(0.95)'
                         }}
                       ></SwiperSlide>
                    ))
                   : layout.trending_product_carousal && (
                     <>
                       {layout.trending_product_carousal.map((image, index) => (
                        
   <SwiperSlide className="book-item zoom-img px-2">
              <Link to={`${image?.imageUrlInput?.replace('{{id}}', slug )}`}  >
                <img src={image.imageInput}   alt={image.imageTITInput}  className="img-fluid" />
              </Link>
            </SwiperSlide>
 
                 ))}
                     </>
                   )}


          
          </Swiper>
        </div>
      </div>
    </div>
  </section>
  {/* Salon Spa and message services */}

  

   {/* <section className="bg-white pt-5">
    <div className="container pt-4">
      <div className="row mb-5">
        <div className="col-12">
          <div className="text-center">
            <h2 className="fw-bold">Home Cleaning Services</h2>
            <p className="text-muted m-0">
              Professional, Hygienic &amp; Affordable Cleaning Solutions
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} >
          <Swiper className="slider-five pb-4" slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 5,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]} >
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/best-offer-1.webp"
                    alt="Washroom Cleaning"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">Washroom Cleaning</p>
                  <p className="text-muted small m-0">Starts at ₹299</p>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/cooking-service.webp"
                    alt="Cooking Service"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">Cooking Service</p>
                  <p className="text-muted small m-0">From ₹999/day</p>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/best-offer-3.webp"
                    alt="Full Home Cleaning"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">Full Home Cleaning</p>
                  <p className="text-muted small m-0">Flat ₹500 off</p>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/best-offer-2.webp"
                    alt="Kitchen Cleaning"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">Kitchen Cleaning</p>
                  <p className="text-muted small m-0">Deep clean at ₹399</p>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/best-offer-4.webp"
                    alt="3BHK Cleaning"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">3BHK Cleaning</p>
                  <p className="text-muted small m-0">Special offer ₹2499</p>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/best-offer-3.webp"
                    alt="2BHK Cleaning"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">2BHK Cleaning</p>
                  <p className="text-muted small m-0">Now at ₹1799</p>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="service-item px-2">
              <a href="/category.php" className="link-dark">
                <div className="zoom-img">
                  <img
                    src="/assets/img/best-offer-4.webp"
                    alt="1 Room Cleaning"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center pt-3">
                  <p className="fw-semibold mb-0">1 Room Cleaning</p>
                  <p className="text-muted small m-0">Quick clean ₹499</p>
                </div>
              </a>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </section> */}
  
  {/* Customer safety is our priority */}
  <div className="py-5 bg-white">
    <div className="container py-4">
      <div className="row mb-5">
        <div className="col-12">
          <div className="text-center">
            <h2 className="fw-bold">Customer safety is our priority</h2>
            <p className="text-muted m-0">
              What customer are saying about our safety standards
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 "      onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} >
          <Swiper  slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]}
             className="slider-three pb-4">

 
{layout.latest_product_carousal && layout.latest_product_carousal.length !== 0 &&
  layout.latest_product_carousal.map((product, index) => (
            <SwiperSlide className="item px-2">
              <div className="bg-light p-4 rounded-3 overflow-hidden review-item">
                <div className="d-flex align-items-center mb-4">
                  
                     <img
              src={product.imageInput}
                    className="img-fluid rounded-circle shadow-sm"
                    alt="Reviewer"
                  />
                  <div className="ms-3">
                    <h6 className="mb-0 fw-bold text-dark"> {product.imageTITInput} </h6>
                    <p className="text-black-50 small mb-0">
                      Best Service
                    </p>
                    <div className="rating">
                      <span className="ri-star-s-fill text-warning" />
                      <span className="ri-star-s-fill text-warning" />
                      <span className="ri-star-s-fill text-warning" />
                      <span className="ri-star-s-fill text-warning" />
                      <span className="ri-star-s-fill text-warning" />
                    </div>
                  </div>
                </div>
                <p className="m-0">
                {product.imageUrlInput}
                </p>
              </div>
            </SwiperSlide>
           ))
}
          </Swiper>
        </div>
      </div>
    </div>
  </div>
  {/* End Verify Offcanvas */}
  <div className="pt-5 bg-light">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6 pe-lg-5 me-auto pb-5">
          <h1 className="fw-bold mb-3 text-body lh-sm">
               {layout.collection_heading}
          </h1>
          <p className="text-muted">
       {layout.collection_paragraph}
          </p>
          <form className="row g-3 mb-5">
            <div className="col-md-auto col-12">
              <Link to={layout.collection_url} className="btn btn-dark btn-lg px-4">
                Book Now
              </Link>
            </div>
          </form>
          {/* <a class="me-2" href="#"><img src="/assets/img/site/google.png" class="img-fluid app-icon" alt="#" loading="lazy"></a>
            <a href="#"><img src="/assets/img/site/apple.png" class="img-fluid app-icon" alt="#" loading="lazy"></a> */}
        </div>
        <div className="col-lg-5 ps-lg-5">
          <img
             src={layout.collection_img}
            className="img-fluid"
            alt="#"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
  {/* Most Popular Cities */}
  
 
 

      <Footer />
    </>
  );
};

export default Home;
